// Login.tsx
import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Container,
  InputAdornment,
  CircularProgress,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import { useAuth } from "../../contexts/AuthContext";
import LogoIcon from "../../components/LogoIcon";
import AppIcon from "../../assets/logo.png";
import { Requests } from "../../common/requests";
import { ENDPOINTS, getApiUrl } from "../../common/endpoints";
const Login: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const apiUrl = getApiUrl(ENDPOINTS.POST_LOGIN);
    setIsLoading(true);
    try {
      const data = await Requests.post(apiUrl, {
        email,
        password,
      });
      if (data?.access_token) login(data.access_token);
    } catch (e) {}
    setIsLoading(false);
  };
  return (
    <Box
      // component="main"
      sx={{
        backgroundColor: "#F7FAFC",
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img src={AppIcon} />
      <LogoIcon />
      <Box
        sx={{
          backgroundColor: "#FFFFFF",
          borderRadius: "10px",
          padding: "20px",
          maxWidth: "400px",
          marginTop: "20px",
        }}
      >
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <TextField
            sx={{
              backgroundColor: "#EDF2F7",
              borderRadius: "5px",
              color: "#2A4365",
              "& label": {
                color: "#2A4365",
              },
              "& svg": {
                color: "#2A4365",
              },
              "& fieldset": {
                border: "none",
              },
              "& input": { padding: "10px" },
            }}
            margin="normal"
            required
            fullWidth
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EmailIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            sx={{
              backgroundColor: "#EDF2F7",
              borderRadius: "5px",
              color: "#2A4365",
              "& label": {
                color: "#2A4365",
              },
              "& svg": {
                color: "#2A4365",
              },
              "& fieldset": {
                border: "none",
              },
              "& input": { padding: "10px" },
            }}
            margin="normal"
            required
            fullWidth
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockIcon />
                </InputAdornment>
              ),
            }}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{
              margin: "40px 0 10px 0",
              backgroundColor: "#2A4365",
              textTransform: "initial",
              height: "40px",
            }}
            disabled={isLoading}
          >
            {isLoading && (
              <CircularProgress
                size="30px"
                sx={{
                  marginRight: "10px",
                  color: "#fff",
                }}
              />
            )}
            Log In
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Login;
